import { render, staticRenderFns } from "./TheUpload.vue?vue&type=template&id=c4dba61e&"
import script from "./TheUpload.vue?vue&type=script&lang=js&"
export * from "./TheUpload.vue?vue&type=script&lang=js&"
import style0 from "./TheUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheUpload.vue"
export default component.exports